module.exports = __webpack_public_path__ + "img/receiver.48546adc.png";